import React, { memo,useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';

// Components
import SocialIcons from '../SocialIcon/SocialIcons';
import FooterMenu, { Footer } from './Footer';

// Data
import useFooterData from './FooterData';
import axios from 'axios';
import config from '../../config';
import Markdown from "react-markdown";
import gfm from "remark-gfm";

const iconData = [
  {
    color: '#828282',
    link: 'https://www.facebook.com/',
    icon: 'fab fa-facebook-f',
  },
  {
    color: '#828282',
    link: 'https://dribbble.com/',
    icon: 'fab fa-dribbble',
  },
  {
    color: '#828282',
    link: 'https://twitter.com/',
    icon: 'fab fa-twitter',
  },
  {
    color: '#828282',
    link: 'https://www.instagram.com/',
    icon: 'fab fa-instagram',
  },
];

const FooterStyle03 = (props) => {
  const { t, i18n } = useTranslation();
  const footerData = useFooterData();
  const isRtl = i18n.language === 'ar';
  const direction = isRtl ? 'rtl' : 'ltr';

  const [pageData, setPageData] = useState({
    title: { fr: "", ar: "" },
    description: { fr: "", ar: "" },
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPageApropos = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${config.SITE_API_URL}/page_aprops`,
        { headers: { 'x-api-key': config.SITE_API_KEY } }
      );
      const data = response?.data?.result || { title: { fr: "", ar: "" }, description: { fr: "", ar: "" } };
      setPageData(data);
    } catch (err) {
      console.error("Erreur lors du chargement de la page À propos :", err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPageApropos();
  }, [i18n.language]); // Re-fetch si la langue change (au cas où l'API gère le multilangue)

  // Sélection dynamique du titre et de la description selon la langue
  const currentTitle = isRtl ? pageData.title.ar : pageData.title.fr;
  const currentDescription = isRtl ? pageData.description.ar : pageData.description.fr;

  return (
    <Footer theme={props.theme} className={`${props.className ? ` ${props.className}` : ''} footer-style-03`} style={{ direction }}>
      <div className="py-[6%] lg:py-[8%] md:py-[50px] md:pb-0 xs:py-[50px]">
        <Container>
          <Row className="justify-between md:justify-start">
            <Col lg={{ span: 5, order: 0 }} sm={{ span: 6, order: 1 }} className="md:mb-[40px] xs:mb-[25px]">
              <span className="font-serif  font-bold text-lg block text-themecolor mb-[20px] xs:mb-[10px]">
                {t('about_company')}
              </span>
              <p className="md:w-9/12 xs:w-full">
                <Markdown remarkPlugins={[gfm]}>
                                        {currentDescription || t('apropos.defaultDescription', { defaultValue: '' })}
                                      </Markdown>
              </p>
            </Col>
            <FooterMenu
              data={footerData}
              lg={{ span: 2, order: 0 }}
              md={6}
              sm={{ span: 6, order: 2 }}
              className="xl:px-[15px] md:mb-[40px] xs:mb-[25px] text-center"
              titleClass="capitalize leading-[20px] mb-[25px]"
            />
          </Row>
        </Container>
      </div>
      <div className="py-[10px] border-t border-[#ffffff1a] bg-white">
        <Container>
          <Row>
            <Col md={3} className="sm:mb-[20px]">
              <Link aria-label="link" to="/" className="sm:flex sm:justify-center">
                <img src="/logo-Jaafar-Academy-V.png" alt="logo" width="150" height="150" />
              </Link>
            </Col>
            <Col md={6} className="grid justify-center content-center sm:mb-[20px]">
              <p className="mb-0 text-dark text-xl xs:text-center">
                {t('copyright', { year: new Date().getFullYear() })}
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </Footer>
  );
};

FooterStyle03.defaultProps = {
  logo: '/assets/img/webp/logo-white.webp',
};

FooterStyle03.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.string,
};

export default memo(FooterStyle03);